/* ============================================================
   METRO theme JS — cart, drawers, reveal, countdown, sticky ATC
   ============================================================ */
(function () {
  'use strict';
  var M = window.METRO || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = M.moneyFormat || '${{amount}}';
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var valueNoDec = Math.round(cents / 100).toLocaleString();
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, valueNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, valueNoDec);
  }
  window.metroMoney = formatMoney;

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-open');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2200);
  }

  /* ---------- drawers / overlay ---------- */
  var overlay = $('[data-overlay]');
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    d.setAttribute('aria-hidden', 'false');
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    var modal = $('.modal.is-open'); if (modal) modal.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- modal (size chart etc) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-modal-open]');
    if (t) { e.preventDefault(); var m = document.getElementById(t.getAttribute('data-modal-open')); if (m) { m.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.classList.add('no-scroll'); } }
    if (e.target.closest('[data-modal-close]')) { e.preventDefault(); closeDrawers(); }
  });

  /* ============================================================
     CART
     ============================================================ */
  function getCart() { return fetch(M.routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function freeShipBar(cart) {
    var bar = $('[data-freeship]'); if (!bar) return;
    var threshold = (M.freeShipThreshold || 0) * 100;
    if (!threshold) { bar.style.display = 'none'; return; }
    var fill = $('[data-freeship-fill]', bar), msg = $('[data-freeship-msg]', bar);
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (cart.total_price >= threshold) msg.innerHTML = '🔥 You unlocked <b>FREE shipping</b>';
      else msg.innerHTML = 'Add <b>' + formatMoney(threshold - cart.total_price) + '</b> for FREE shipping';
    }
  }

  function renderCartDrawer(cart) {
    var body = $('[data-cart-items]');
    updateCartCount(cart.item_count);
    var subtotalEls = $$('[data-cart-subtotal]');
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p class="text-muted">Your bag is empty.</p><a href="/collections/all" class="btn btn--accent" data-drawer-close>Start shopping</a></div>';
      var foot = $('[data-cart-foot]'); if (foot) foot.style.display = 'none';
      freeShipBar(cart);
      return;
    }
    var footEl = $('[data-cart-foot]'); if (footEl) footEl.style.display = '';
    var html = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
      var variant = (it.product_has_only_default_variant) ? '' : '<div class="cart-item__variant">' + it.options_with_values.map(function (o) { return o.value; }).join(' / ') + '</div>';
      return '<div class="cart-item" data-line-item="' + it.key + '">' +
        '<a href="' + it.url + '"><img class="cart-item__img" src="' + img + '" alt="" width="74" height="74" loading="lazy"></a>' +
        '<div><a href="' + it.url + '"><h4 class="cart-item__title">' + it.product_title + '</h4></a>' + variant +
        '<div class="qty"><button data-qty-down aria-label="Decrease">&minus;</button>' +
        '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-qty-input data-key="' + it.key + '" aria-label="Quantity">' +
        '<button data-qty-up aria-label="Increase">+</button></div></div>' +
        '<div style="text-align:right"><div class="price__regular">' + formatMoney(it.final_line_price) + '</div>' +
        '<button class="cart-item__remove" data-remove="' + it.key + '">Remove</button></div>' +
        '</div>';
    }).join('');
    body.innerHTML = html;
    freeShipBar(cart);
  }

  function refreshCart() { return getCart().then(renderCartDrawer); }

  function changeLine(key, qty) {
    return fetch(M.routes.cart_change, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function addToCart(formData, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(M.routes.cart_add, {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: formData
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.data.description || 'Could not add'); return null; }
        toast(M.strings.added || 'Added to bag');
        return refreshCart().then(function () { openDrawer('CartDrawer'); });
      }).catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Network error'); });
  }
  window.metroAddToCart = addToCart;

  /* product / quick-add form submit */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    addToCart(new FormData(form), btn);
  });

  /* Buy now — add current variant then go straight to checkout */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (!b || b.disabled) return;
    var form = b.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    b.classList.add('is-loading');
    fetch(M.routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { b.classList.remove('is-loading'); toast(res.data.description || 'Could not add'); return; }
        window.location.href = '/checkout';
      })
      .catch(function () { b.classList.remove('is-loading'); toast('Network error'); });
  });

  /* cart drawer interactions */
  document.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-remove]');
    if (rem) { changeLine(rem.getAttribute('data-remove'), 0); return; }
    var up = e.target.closest('[data-qty-up]'), down = e.target.closest('[data-qty-down]');
    if (up || down) {
      var wrap = (up || down).closest('.qty');
      var input = wrap.querySelector('[data-qty-input]');
      var key = input.getAttribute('data-key');
      var val = parseInt(input.value, 10) || 1;
      val = up ? val + 1 : Math.max(0, val - 1);
      if (key) changeLine(key, val); else input.value = Math.max(1, val);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input][data-key]');
    if (input) { var v = Math.max(0, parseInt(input.value, 10) || 0); changeLine(input.getAttribute('data-key'), v); }
  });

  /* ============================================================
     PRODUCT — variant selection
     ============================================================ */
  $$('[data-product-root]').forEach(function (root) {
    var dataEl = $('[data-variants-json]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var addBtn = $('[data-add-btn]', root);
    var buyBtn = $('[data-buy-now]', root);
    var stickyPrice = $('[data-sticky-price]');

    function currentOptions() {
      return $$('[data-opt]', root).map(function (group) {
        var sel = group.querySelector('input:checked') || group.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function setAvailability(opts) {
      // disable size options that are sold out given selected color (first option)
      $$('[data-opt]', root).forEach(function (group, gi) {
        $$('input[type=radio]', group).forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var match = variants.find(function (v) { return v.options.slice(0, gi + 1).every(function (o, i) { return i === gi ? o === inp.value : o === test[i]; }); });
          if (gi === opts.length - 1) {
            var exact = findVariant(test);
            inp.disabled = exact ? !exact.available : true;
          }
        });
      });
    }
    function update() {
      var opts = currentOptions();
      var v = findVariant(opts);
      setAvailability(opts);
      $$('[data-opt]', root).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var lbl = group.querySelector('[data-opt-selected]');
        if (checked && lbl) lbl.textContent = checked.value;
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('.btn__text').textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price); compareEl.style.display = '';
          priceEl.classList.add('on-sale');
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('.btn__text').textContent = v.available ? (addBtn.getAttribute('data-add-label') || 'Add to bag') : 'Sold out';
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      // update URL
      if (history.replaceState) {
        var u = new URL(window.location); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-opt]')) update(); });
    update();
  });

  /* ============================================================
     STICKY ATC (mobile)
     ============================================================ */
  var sticky = $('[data-sticky-atc]');
  if (sticky) {
    var anchor = $('[data-atc-anchor]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' });
    if (anchor) io.observe(anchor);
    var sbtn = $('[data-sticky-add]', sticky);
    if (sbtn) sbtn.addEventListener('click', function () { var f = $('form[data-product-form]'); if (f) f.requestSubmit ? f.requestSubmit() : f.querySelector('[type=submit]').click(); });
  }

  /* ============================================================
     REVEAL animations
     ============================================================ */
  if (document.body.classList.contains('anim-on') && 'IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal]').forEach(function (el, i) { el.style.setProperty('--anim-delay', (i % 6) * 60); rio.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ============================================================
     ACCORDION
     ============================================================ */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc__q'); if (!q) return;
    var item = q.closest('.acc__item');
    var ans = item.querySelector('.acc__a');
    var open = item.classList.toggle('is-open');
    ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
    q.setAttribute('aria-expanded', open);
  });

  /* ============================================================
     COUNTDOWN
     ============================================================ */
  $$('[data-countdown]').forEach(function (el) {
    var endAttr = el.getAttribute('data-countdown'); // ISO or "evergreen:hours"
    var end;
    if (endAttr.indexOf('evergreen:') === 0) {
      var hrs = parseFloat(endAttr.split(':')[1]) || 24;
      var key = 'metro_cd_' + (el.getAttribute('data-cd-id') || 'default');
      var stored = localStorage.getItem(key);
      if (stored && parseInt(stored, 10) > Date.now()) end = parseInt(stored, 10);
      else { end = Date.now() + hrs * 3600 * 1000; localStorage.setItem(key, end); }
    } else { end = new Date(endAttr).getTime(); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000), h = Math.floor(diff % 86400000 / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
      var set = function (k, v) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = (v < 10 ? '0' : '') + v; };
      set('d', d); set('h', h); set('m', m); set('s', s);
      if (diff <= 0) clearInterval(el._t);
    }
    tick(); el._t = setInterval(tick, 1000);
  });

  /* ============================================================
     COPY CODE
     ============================================================ */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]'); if (!c) return;
    var code = c.getAttribute('data-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { toast('Code ' + code + ' copied'); });
  });

  /* ============================================================
     PREDICTIVE SEARCH (lightweight)
     ============================================================ */
  var searchInput = $('[data-predictive-input]');
  if (searchInput) {
    var resultsBox = $('[data-predictive-results]');
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (q.length < 2) { if (resultsBox) resultsBox.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(M.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (!resultsBox) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-results]');
            resultsBox.innerHTML = inner ? inner.innerHTML : '';
          });
      }, 250);
    });
  }

  /* initial cart sync for count */
  if ($('[data-cart-items]')) refreshCart();
})();

/* ===== Marquee / announcement — delta-time JS engine (frame-rate independent, glitch-free) ===== */
(function(){
  function engine(track, pxPerSec, copies, reverse){
    if(!track || track.dataset.mqEngine) return;
    track.dataset.mqEngine = '1';
    var offset = 0, last = null, copyW = 0;
    function measure(){ copyW = track.scrollWidth / copies; }
    /* kill any CSS animation — JS fully drives it now */
    track.style.animation = 'none';
    track.style.willChange = 'transform';
    measure();
    function frame(ts){
      if(last === null) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if(dt < 0 || dt > 0.1) dt = 0.016; /* cap big gaps (tab switch / throttling) */
      if(copyW > 0){
        offset += pxPerSec * dt;
        while(offset >= copyW) offset -= copyW;
        var x = reverse ? (offset - copyW) : (-offset);
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(measure, 150); });
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ setTimeout(measure, 50); }); }
    window.addEventListener('load', function(){ setTimeout(measure, 50); });
  }
  function boot(){
    document.querySelectorAll('.announcement__track').forEach(function(tr){ engine(tr, 45, 2, false); });
    document.querySelectorAll('.marquee__track').forEach(function(tr){
      var wrap = tr.closest('.marquee');
      var rev = wrap && wrap.classList.contains('marquee--reverse');
      engine(tr, 85, 3, rev);
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
